// extracted by mini-css-extract-plugin
export default {"sidebar-title":"styles_sidebar-title__hzw2b"};